// import googleCSV from "contact.csv";
// import contactOutlook from "contact_outlook.csv";
import iosVCF from "./contact.vcf"

// Select languages
import i18n from "./i18n"
import { withTranslation } from "react-i18next"
import { Dropdown } from "react-bootstrap"
import { useEffect } from "react"

// images
import logoUidb from "./assets/img/logo-uidb.png"
import orChuImg from "./assets/img/orchuban profile.png"
import diskIcon from "./assets/img/disk.png"
import phoneIcon from "./assets/img/phone.png"
import envelopeIcon from "./assets/img/envelope.png"
import linkedinIcon from "./assets/img/in.png"
import websiteIcon from "./assets/img/earth.png"
import githubIcon from "./assets/img/github.png"
import spnader from "./assets/img/spander.png"
import maxsens from "./assets/img/maxsens.png"
import voximaLogo from "./assets/img/voxima-logo-black.png"	


// #Hooks
import {
	useParams,
	useNavigate,
	BrowserRouter as Router,
	Routes,
	Route,
} from "react-router-dom"
import { createBrowserHistory } from "history"

import "./style.css"
import "./index.css"

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

// Router
const history = createBrowserHistory()

const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1]
if (path) {
	history.replace(path)
}

const AppWithRouter = props => (
	<Router>
		<Routes>
			<Route path="/:language" element={<App {...props} />} />
			<Route path="/" element={<App {...props} />} />
		</Routes>
	</Router>
)

function App(props) {
	// const isIOS = () => {
	//   return (
	//     [
	//       "iPad Simulator",
	//       "iPhone Simulator",
	//       "iPod Simulator",
	//       "iPad",
	//       "iPhone",
	//       "iPod",
	//     ].includes(navigator.platform) ||
	//     // iPad on iOS 13 detection
	//     (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	//   );
	// };

	const saveInfoFile = () => {
		// const ansIsIOS = isIOS();
		// if (ansIsIOS)
		window.open(iosVCF)
		// else window.open(googleCSV);
	}
	// const saveInfoFile = () => {
	//   const ansIsIOS = isIOS();
	//   if (ansIsIOS) return iosVCF;
	//   // window.open(iosVCF);
	//   else return googleCSV; //window.open(googleCSV);
	// };

	const { language } = useParams()
	const navigate = useNavigate()

	useEffect(() => {
		// Only change language if it's defined and different
		if (language && i18n.language !== language) {
			i18n.changeLanguage(language)
		}
	}, [language])

	const switchLanguage = (newLang) => {
		navigate(`/${newLang}`)
	}

	useEffect(() => {
		// Set meta tags dynamically based on language
		const currentLang = language || i18n.language || 'en'
		const isHebrew = currentLang === 'he'
		
		// Update HTML lang attribute (keep LTR for layout stability)
		document.documentElement.lang = currentLang
		
		// SEO content per language
		const seoContent = {
			en: {
				title: 'Chuban — Or Chuban (אור צ׳ובן / אור צובן) | Tech Entrepreneur, CEO & Founder UIDB Group',
				description: 'Chuban — Or Chuban (also: Chouban, Tzuban). Tech entrepreneur cracking software innovation challenges. CEO and Founder of UIDB Group. Expert in software, app and innovative technology solutions.',
			},
			he: {
				title: 'Chuban — אור צ\'ובן (אור צובן) | יזם טכנולוגי, ומפצח אתגרי חדשנות תוכנה. מנכ״ל ומייסד קבוצת UIDB',
				description: 'אור צ\'ובן (Chuban / Chouban / Tzuban) - מנכ"ל ומייסד קבוצת UIDB. מומחה בפיתוח תוכנה, אפליקציות ופתרונות טכנולוגיים חדשניים. (אור צובן, צ\'ובן, צובן)',
			}
		}
		
		const content = seoContent[currentLang] || seoContent.en
		
		// Update title
		document.title = content.title
		
		// Helper to set meta tags
		const setMetaTag = (selector, content) => {
			const meta = document.querySelector(selector)
			if (meta) meta.setAttribute('content', content)
		}
		
		// Update meta tags
		setMetaTag('meta[name="description"]', content.description)
		setMetaTag('meta[property="og:title"]', content.title)
		setMetaTag('meta[property="og:description"]', content.description)
		setMetaTag('meta[property="og:locale"]', isHebrew ? 'he_IL' : 'en_US')
		setMetaTag('meta[name="twitter:title"]', content.title)
		setMetaTag('meta[name="twitter:description"]', content.description)
		
		// Update canonical URL
		const canonical = document.querySelector('link[rel="canonical"]')
		if (canonical) {
			canonical.setAttribute('href', `https://orchuban.com/${currentLang}`)
		}
	}, [language])

	return (
		<div>
			<div className="select-language-area">
				<Dropdown>
					<Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
						{language || i18n.language}
					</Dropdown.Toggle>

					<Dropdown.Menu>
						<Dropdown.Item onClick={() => switchLanguage("en")}>
							English
						</Dropdown.Item>
						<Dropdown.Item onClick={() => switchLanguage("he")}>
							עברית
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</div>{" "}
			<div className="header-area">
				<span className="line" />
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="logo">
								<a href="https://ui-db.com">
									<img src={logoUidb} alt="" />
								</a>
								{/* <h2>
                  systems <br />
                  development
                </h2> */}
							</div>
							<div className="author">
								<img src={orChuImg} alt="" />
							</div>

							<div title={props.t("Or Chuban/ title")} className="author-info">
								<h1 className="visually-hidden-seo">
									Chuban — Or Chuban | Chouban | Tzuban | אור צ'ובן | אור צובן
								</h1>
								<h2>{props.t("Or Chuban")}</h2>
								<p>{props.t("CEO UI-DB")}</p>
								<span className="visually-hidden-seo">
									Chuban, Or Chuban, Chouban, Or Chouban, Tzuban, Or Tzuban, Tsuban,
									אור צ'ובן, אור צובן, צ'ובן, צובן,
									מנכ"ל UIDB, יזם טכנולוגי, מפתח תוכנה, מייסד קבוצת UIDB.
								</span>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="share" /> */}
			</div>
			<div className="section-area">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="main-menu">
								<ul>
									<li>
										<a
											className="save-cursor"
											href={"false"}
											onClick={saveInfoFile}
											// download={`${isIOS()?"OrChuban.vcf":"OrChuban.csv"}`}
											download={"OrChuban.vcf"}
										>
											<span className="icon">
												<img src={diskIcon} alt="save business card" />
											</span>
											{props.t("save")}
										</a>
									</li>
									<li>
										<a href="tel:+972532002314">
											<span className="icon">
												<img src={phoneIcon} alt="call me" />
											</span>
											{props.t("call me")}
										</a>
									</li>
									<li>
										<a href="mailto:or@ui-db.com?Subject=Hey Or Chuban">
											<span className="icon">
												<img src={envelopeIcon} alt="email" />
											</span>
											{props.t("email")}
										</a>
									</li>

									<li>
										<a href="https://ui-db.com">
											<span className="icon">
												<img src={websiteIcon} alt="website icon" />
											</span>
											{props.t("UI-DB website")}
										</a>
									</li>
									{/* <li>
                    <a href="https://www.waze.com/ul?ll=32.767761,34.972618&zoom=17">
                      <span className="icon">
                        <img src="assets/img/map.png" alt="" />
                      </span>
                      ADDRESS
                    </a>
                  </li> */}
									<li>
										<a href="https://www.linkedin.com/in/or-chuban-028280125">
											<span className="icon">
												<img src={linkedinIcon} alt="linkedin" />
											</span>
											{props.t("linkedin")}
										</a>
									</li>
									<li>
										<a href="https://github.com/orchuban">
											<span className="icon">
												<img src={githubIcon} alt="github" />
											</span>
											{props.t("github")}
										</a>
									</li>
									{/* <li>
                    <a href="https://ui-db.com">
                      <span className="icon">
                        <img src="assets/img/info.png" alt="" />
                      </span>
                      ABOUT US
                    </a>
                  </li> */}
								</ul>
							</div>

							<div className="project">
								<a target="_blank" href="https://spander.ui-db.com/">
									<img src={spnader} alt="Spander logo" />
								</a>
								<a target="_blank"href="https://maxsense.live/">
									<img src={maxsens} alt="Maxsense logo" />
								</a>
								<a target="_blank" href="https://voxima.ai/">
									<img src={voximaLogo} alt="Voxima AI logo" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default withTranslation()(AppWithRouter)
